import { AnalyticsEvent as LegacyAnalyticsEvent } from '@backstage/core-plugin-api';
import {
  AnalyticsEvent,
  AnalyticsImplementation,
} from '@backstage/frontend-plugin-api';

import { Confidence } from '@spotify-confidence/sdk';

import { getUserContextFromToken } from '../behaviors/auth-factory/auth0/jwt';
import { ConfidenceUserApi } from './UserApi';

export class ConfidenceAnalytics implements AnalyticsImplementation {
  confidenceApi: Confidence;
  confidenceUserApi: ConfidenceUserApi;

  constructor({
    confidenceApi,
    confidenceUserApi,
  }: {
    confidenceApi: Confidence;
    confidenceUserApi: ConfidenceUserApi;
  }) {
    this.confidenceApi = confidenceApi;
    this.confidenceUserApi = confidenceUserApi;
  }

  private async getAccessToken(): Promise<string | undefined> {
    try {
      return await this.confidenceUserApi.getAccessToken({
        cacheOnly: true,
      });
    } catch {
      return undefined;
    }
  }

  async captureEvent(event: AnalyticsEvent | LegacyAnalyticsEvent) {
    const { action, subject, value, attributes = {} } = event;

    const token = await this.getAccessToken();
    const user = (token ? getUserContextFromToken(token) : undefined) ?? {};

    try {
      this.confidenceApi
        .withContext({
          user,
        })
        .track(action, {
          subject,
          value: value || 0,
          attributes,
        });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }
}
